/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { PartnerTiersType } from 'app/developer-v3/types/partnerDashboard';

import BronzeSvg from '../images/tiers/bronze.svg';
import GoldSvg from '../images/tiers/gold.svg';
import PlatinumSvg from '../images/tiers/platinum.svg';
import SilverSvg from '../images/tiers/silver.svg';

const Styles = {
  trophyImage: ({
    isActive,
    isCompleted,
    isTooltip,
  }: {
    isActive?: boolean;
    isCompleted?: boolean;
    isTooltip?: boolean;
  }) => [
    css`
      width: 36px;
      height: 38px;
      position: absolute;
      display: flex;
      align-self: center;
      width: 50px;
      height: 53px;
    `,
    isActive &&
      css`
        width: 40px;
        height: 43px;
        @media screen and (min-width: 760px) {
          width: 50px;
          height: 53px;
        }
      `,
    isActive &&
      css`
        width: 50px;
        height: 53px;
      `,
    isTooltip &&
      css`
        width: 63px;
        height: 66px;
      `,
    isCompleted &&
      css`
        opacity: 0.5;
      `,
  ],
};

type TrophyCssType = {
  isActive?: boolean;
  isCompleted?: boolean;
  isTooltip?: boolean;
};

type Props = {
  iconType: TrophyCssType;
  tier: PartnerTiersType;
};

function TierSvgWrapper(props: Props) {
  const { iconType, tier } = props;

  let Svg = null;
  switch (tier) {
    case PartnerTiersType.BRONZE: {
      Svg = BronzeSvg;
      break;
    }
    case PartnerTiersType.SILVER: {
      Svg = SilverSvg;
      break;
    }
    case PartnerTiersType.GOLD: {
      Svg = GoldSvg;
      break;
    }
    case PartnerTiersType.PLATINUM: {
      Svg = PlatinumSvg;
      break;
    }
  }

  return <Svg css={Styles.trophyImage({ ...iconType })} />;
}

export default TierSvgWrapper;
